import {
  SESSION_KEY_EZIOK_CERT_AUTH_VALUE_ENC,
  SESSION_KEY_MASKING_USER_PHONE,
} from "@/types";

export function handleAuthValue() {
  const setAuthValueToSessionStorage = (
    maskingUserphone: string,
    eziokCertAuthValueEnc: string
  ) => {
    window.sessionStorage.setItem(
      SESSION_KEY_MASKING_USER_PHONE,
      maskingUserphone
    );
    window.sessionStorage.setItem(
      SESSION_KEY_EZIOK_CERT_AUTH_VALUE_ENC,
      eziokCertAuthValueEnc
    );
  };

  const getAuthValueFromSessionStorage = () => {
    const maskingUserphone = window.sessionStorage.getItem(
      SESSION_KEY_MASKING_USER_PHONE
    );
    const eziokCertAuthValueEnc = window.sessionStorage.getItem(
      SESSION_KEY_EZIOK_CERT_AUTH_VALUE_ENC
    );

    return { maskingUserphone, eziokCertAuthValueEnc };
  };

  const removeAuthValueFromSessionStorage = () => {
    window.sessionStorage.removeItem(SESSION_KEY_MASKING_USER_PHONE);
    window.sessionStorage.removeItem(SESSION_KEY_EZIOK_CERT_AUTH_VALUE_ENC);
  };

  return {
    setAuthValueToSessionStorage,
    getAuthValueFromSessionStorage,
    removeAuthValueFromSessionStorage,
  };
}
